import api from '@/api';
import utilities from '@/helpers/utilities';

const state = {
    units: [],
};

const mutations = {
    setUnits(state, units) {
        state.units = units;
    },
};

const actions = {
    async loadUnits({ commit }) {
        const response = await api.units.list();
        commit('setUnits', response.data);
    },
};

const getters = {
    units() {
        const units = state.units || [];
        return units.sort((a, b) => utilities.stringCompare(a.name, b.name));
    },
    unitsValueText(_, getters) {
        return getters.units.map(({ id, name }) => ({ value: id, text: name }));
    },
    unitsDictionary(_, getters) {
        return getters.units.reduce((map, obj) => {
            map[obj.id] = obj;
            return map;
        }, {});
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/units.js